import { render } from "./mainFrame.vue?vue&type=template&id=df4510fe&scoped=true"
import script from "./mainFrame.vue?vue&type=script&lang=js"
export * from "./mainFrame.vue?vue&type=script&lang=js"

import "./mainFrame.vue?vue&type=style&index=0&id=df4510fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4510fe"]])

export default __exports__